import { FC, forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core';
import { ReactComponent as GpmSvg } from './gpm.svg';
import { ReactComponent as GpmLogoSvg } from './gpmLogo.svg';
import { ReactComponent as ArrowSvg } from './arrow.svg';
import { ReactComponent as PlayBtnSvg } from './playBtn.svg';
import { ReactComponent as ArchitectureIconSvg } from './architectureIcon.svg';
import { ReactComponent as GpmModuleSvg } from './gpmModule.svg';
import { ReactComponent as DataSphereModuleSvg } from './dataSphereModule.svg';
import { ReactComponent as PayrollModuleSvg } from './payrollModule.svg';
import { ReactComponent as WymsModuleSvg } from './wymsModule.svg';
import { ReactComponent as PlusIconSvg } from './plusIcon.svg';
import { ReactComponent as LineSvg } from './line.svg';
import { ReactComponent as ArrowDownSvg } from './arrowDown.svg';

export const GpmIcon: FC<SvgIconProps> = forwardRef((props, ref) => <GpmSvg ref={ref} {...props} />);
export const GpmLogoIcon: FC<SvgIconProps> = forwardRef((props, ref) => <GpmLogoSvg ref={ref} {...props} />);
export const ArrowIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ArrowSvg ref={ref} {...props} />);
export const PlayBtn: FC<SvgIconProps> = forwardRef((props, ref) => <PlayBtnSvg ref={ref} {...props} />);
export const ArchitectureIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ArchitectureIconSvg ref={ref} {...props} />);
export const GpmModule: FC<SvgIconProps> = forwardRef((props, ref) => <GpmModuleSvg ref={ref} {...props} />);
export const DataSphereModule: FC<SvgIconProps> = forwardRef((props, ref) => <DataSphereModuleSvg ref={ref} {...props} />);
export const PayrollModule: FC<SvgIconProps> = forwardRef((props, ref) => <PayrollModuleSvg ref={ref} {...props} />);
export const WymsModule: FC<SvgIconProps> = forwardRef((props, ref) => <WymsModuleSvg ref={ref} {...props} />);
export const PlusIcon: FC<SvgIconProps> = forwardRef((props, ref) => <PlusIconSvg ref={ref} {...props} />);
export const LineIcon: FC<SvgIconProps> = forwardRef((props, ref) => <LineSvg ref={ref} {...props} />);
export const ArrowDown: FC<SvgIconProps> = forwardRef((props, ref) => <ArrowDownSvg ref={ref} {...props} />);
